import {
  SET_EVOUCHER_ACTIVATION_CODE_DATA,
  SET_EVOUCHER_ACTIVATION_DATA,
  SET_EVOUCHER_DATA,
  SET_EVOUCHER_LIST_DATA,
  UNSET_EVOUCHER_ACTIVATION_DATA,
} from '../../../store/types'
import Vue from 'vue'

export default {
  [SET_EVOUCHER_LIST_DATA](state, payload) {
    Vue.set(state.eVoucherList, 'list', payload.list)
  },
  [SET_EVOUCHER_DATA](state, payload) {
    Vue.set(state.eVoucherData, 'data', payload.data)
  },
  [SET_EVOUCHER_ACTIVATION_DATA](state, payload) {
    Vue.set(state.evoucherActivationRequestData, 'data', payload.data)
  },
  [SET_EVOUCHER_ACTIVATION_CODE_DATA](state, payload) {
    Vue.set(state.evoucherActivationRequestData.data, 'code', payload)
  },
  [UNSET_EVOUCHER_ACTIVATION_DATA](state, payload) {
    Vue.set(state.evoucherActivationRequestData, 'data', {})
  },
}
